export const tool = {
  name: 'download',
  description:
    'A tool that allows downloading the current 3D model or scene in a specific file format.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      fileFormat: {
        type: 'string',
        enum: ['json', 'obj', 'stl', 'glb'],
        default: 'png',
        description: 'The type of file to download. Defaults to json.',
      },
      message: {
        type: 'string',
        default: 'Download model file',
      },
    },
    required: ['message'],
  },
};
